import React, { useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import Moment from 'react-moment';
import { Link } from "react-router-dom";

const BoxUserLogin = () => {
    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    return (
        <>
            <Row>
                <Col md={12}>
                    <strong>User Login</strong>
                    <p className="text-muted"><small>User login yang digunakan saat ini.</small></p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="user-login border rounded-3 mb-3 p-3">
                        <div className="d-flex pb-3">
                            <div className="me-3 avatar">
                                <FaUserCircle />
                            </div>
                            <div className="text">
                                <strong>{`@${userLogin.username}`}</strong><br />
                                <span>{userLogin.email}</span>
                            </div>
                        </div>
                        <Table striped bordered hover size="sm">
                            <tr>
                                <td className="fw-medium" width={130}>Nama Lengkap</td>
                                <td className="text-center fw-medium" width={20}>:</td>
                                <td>{userLogin.name}</td>
                            </tr>
                            <tr>
                                <td className="fw-medium">No Handphone</td>
                                <td className="text-center fw-medium" width={20}>:</td>
                                <td>{userLogin.phone}</td>
                            </tr>
                            <tr>
                                <td className="fw-medium">Tanggal Register</td>
                                <td className="text-center fw-medium" width={20}>:</td>
                                <td><Moment format="DD/MM/YYYY - HH:mm A" className="bg-transparent">{userLogin.createdAt}</Moment></td>
                            </tr>
                            <tr>
                                <td className="fw-medium">Role Akses</td>
                                <td className="text-center fw-medium" width={20}>:</td>
                                <td><span className="badge bg-primary text-light">{userLogin.role.toUpperCase()}</span></td>
                            </tr>
                        </Table>
                        <div className="d-grid gap-2">
                            <Link to={`/account/profile`} className="btn btn-secondary">
                                Ubah profil saya
                            </Link>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default BoxUserLogin;
